<template>
  <div>
    <v-data-table :headers="headers" :items="peerReviews">
      <template v-slot:item.employeeScore="{ item }">
        <span class="supervisor-review-table">{{ MyScore(item) }}%</span>
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn-toggle>
          <v-btn
            small
            color="success"
            tile
            class="ml-2"
            @click="openCommentDialog(item)"
          >
            {{ item.review ? "View Comment" : "Add Comment" }}
            <v-icon right color="white">mdi-comment-plus-outline</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-data-table>

    <!-- Peer Review Dialog -->
    <v-dialog v-model="peerReviewDialog" max-width="600" persistent>
      <v-card>
        <v-card-title>
          Peer Review Feedback
          <v-spacer></v-spacer>
          <v-icon color="error" @click="closeDialog"> mdi-close </v-icon>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="mt-5">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                label="Peer Name"
                readonly
                dense
                outlined
                :value="userData.name"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                label="Peer Number"
                readonly
                dense
                outlined
                :value="userData.employee"
              />
            </v-col>
          </v-row>

          Please provide feedback on the employee's performance.
        </v-card-text>

        <v-card-text>
          <v-textarea
            outlined
            v-model="reviewText"
            placeholder="Add your Peer Review here ..."
            rows="5"
            row-height="25"
            shaped
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="submitPeerComment">
            submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppraisalMixin from "@/packages/cassandra-appraisal/modules/appraisalv3/AppraisalMixin";

export default {
  name: "PeerReviewTable",
  mixins: [AppraisalMixin],

  props: {
    peerReviews: Array,
    headers: {
      type: Array,
      default: () => [
        {
          text: "Review Document",
          sortable: true,
          value: "reviewID",
        },
        {
          text: "PerName Name",
          sortable: true,
          value: "peerName",
        },
        { text: "Actions", value: "action" },
      ],
    },
  },

  data() {
    return {
      peerReviewDialog: false,
      selectedItem: null,
      reviewText: "", // ✅ local state instead of Vuex
    };
  },

  computed: {
    userData() {
      return this.$store.getters["auth/user"];
    },
  },

  methods: {
    openCommentDialog(item) {
      this.selectedItem = item;

      // ✅ Load existing review if available
      this.reviewText = item.review || "";

      this.peerReviewDialog = true;
    },

    closeDialog() {
      this.peerReviewDialog = false;
      this.selectedItem = null;
      this.reviewText = ""; // reset
    },

    submitPeerComment() {
      if (!this.selectedItem) return;

      const data = {
        reviewID: this.selectedItem.reviewID,
        peerNo: this.userData.employee,
        review: this.reviewText,
      };

      this.$store.dispatch("appraisal/peerAddComment", data);

      this.closeDialog(); // optional UX improvement
    },
  },
};
</script>
